import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { groupService } from 'features/services';
import { LoadingStatus, SavingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';

const initialState = {
    groupsStatus: LoadingStatus.Idle,
    groups: [],
    displayGroup: {},
    groupPageInfo: {},
    groupUsage: [],
};

export const fetchGroups = createAsyncThunk('groups/fetchGroups', async (params) => {
    const response = await groupService.fetchFiltered(params.searchString, params.sort);
    return response;
});

export const getGroupById = createAsyncThunk('groups/getGroupById', async (groupId) => {
    const response = await groupService.getById(groupId);
    response.id = groupId;
    return response;
});
export const fetchGroupUsageById = createAsyncThunk(
    'groups/fetchGroupUsageById',
    async (groupId) => await groupService.fetchGroupUsageById(groupId)
);
export const addNewGroup = createAsyncThunk(
    'groups/addNewGroup',
    async (newGroup) => await groupService.create(newGroup)
);

export const editGroup = createAsyncThunk(
    'groups/editGroup',
    async (updates) => await groupService.update(updates.groupId, updates.groupUpdates)
);

export const deleteGroupById = createAsyncThunk('groups/deleteGroupById', async (groupId) => {
    const response = await groupService.delete(groupId);
    response.id = groupId;
    return response;
});

export const deleteGroupArray = createAsyncThunk('assets/deleteGroupArray', async (groupIds) => {
    const response = await groupService.deleteArray(groupIds);
    response.ids = groupIds;
    return response;
});

const groupsSlice = createSlice({
    name: 'groups',
    initialState,
    reducers: {
        setGroupRefreshFlag: (state) => {
            state.groupsStatus = LoadingStatus.Idle;
        },
        resetGroupState: (state) => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGroups.fulfilled, (state, action) => {
                state.groupsStatus = LoadingStatus.Loaded;
                state.groupPageInfo = action.payload.pageInfo;
                state.groups = action.payload.groups;
            })
            .addCase(fetchGroups.rejected, (state, action) => {
                state.groupsStatus = LoadingStatus.Failed;
            })
            .addCase(getGroupById.fulfilled, (state, action) => {
                state.displayGroup = action.payload;
            })
            .addCase(editGroup.fulfilled, (state, action) => {
                const existingGroup = state.groups.find((group) => group.group_id === action.payload.group_id);
                if (existingGroup) {
                    existingGroup.display_name = action.payload.display_name;
                    existingGroup.description = action.payload.description;
                }
            })
            .addCase(addNewGroup.fulfilled, (state, action) => {
                state.groupsStatus = LoadingStatus.Idle;
            })
            .addCase(deleteGroupById.fulfilled, (state, action) => {
                state.groupsStatus = LoadingStatus.Idle;
            })
            .addCase(deleteGroupArray.fulfilled, (state, action) => {
                state.groupsStatus = LoadingStatus.Idle;
            })
            .addCase(deleteGroupArray.rejected, (state, action) => {
                state.status = SavingStatus.Failed;
                state.error = action.error.message;
            })
            .addCase(fetchGroupUsageById.fulfilled, (state, action) => {
                state.groupUsage = action.payload;
            });
    },
});

export const selectAllGroups = (state) => state.groups.groups;
export const getGroupPageInfo = (state) => state.groups.groupPageInfo;
export const getGroupStatus = (state) => state.groups.groupsStatus;
export const getGroupUsage = (state) => state.groups.groupUsage;

export const { setGroupRefreshFlag, resetGroupState } = groupsSlice.actions;

export default groupsSlice.reducer;
